import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=71870c32&scoped=true&"
import script from "./Todos.vue?vue&type=script&lang=js&"
export * from "./Todos.vue?vue&type=script&lang=js&"
import style0 from "./Todos.vue?vue&type=style&index=0&id=71870c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71870c32",
  null
  
)

export default component.exports